import { leaveService } from '../../../services/extensions';
import { setData } from '../../../services/store/userSlice';
import { capitalize } from '../../../services/utility/helper';
const months = [
    {}
]

const getAllLeaves = async () => {
    const resp = await leaveService.getAbsenceCodesByUserLocation();
    let data = { absenceCode: {}, codes: [] };
    if (resp.status === 200) {
        const leaveData = resp.data.data;
        leaveData.map(x => {
            data.absenceCode[x.code] = x
        })
        data.codes = leaveData;
    }
    return data;
}

export const getAbsenceCodesLocationWise = async (allLeavesByUser, userLeaveData, dispatch, userData, user = {}) => {
    const localLeaves = await getAllLeaves();
    return leaveService.getLeavesByUser(user.id).then(resp => {
        const leagalEntity = user['LegalEntity']['code'] || 'ESIN';
        let absCode = {};
        const exLeaveBalanceUK = ['ML', 'ADL', 'BL', 'PBL', 'PAL', 'PL', 'SL', 'SSL'];
        const exLeaveBalanceIN = ['BL', 'LWP', 'WFH', 'WFO', 'ML'];
        let exLeaveBalance = [];
        switch (leagalEntity) {
            case 'ESUK':
                exLeaveBalance = exLeaveBalanceUK; break;
            case 'ESIN':
                exLeaveBalance = exLeaveBalanceIN; break;
            default:
                exLeaveBalance = [];
        }
        const userAbsenceCodes = resp.data.data.map(el => {
            absCode[el.code] = el;
            return {
                ...el,
                label: <span className='ess-list-item'>
                    <strong>{el.code}</strong> ({el.title})
                    <strong style={{ float: 'right' }}>{exLeaveBalance.includes(el.code) ? '' : (el.balance || 0)}</strong>
                    {/* <strong style={{ float: 'right' }}>{(el.balance || 0)}</strong> */}
                </span>
            };
        });

        const updatedAbsenceCode = { ...userLeaveData, userAbsenceCodes };
        const newData = { ...userData, ...updatedAbsenceCode, absenceCode: absCode, localAbsenceCodes: localLeaves.absenceCode, localAbsenceCodesArray: localLeaves.codes }
        dispatch(setData(newData))
        return {
            AbsenceCodesByLocation: resp.data.data,
            UpdatedAbsenceCode: updatedAbsenceCode,
            userAbsenceCodes: userAbsenceCodes,
            userData: newData
        };
    });
};

export const getLeaveTypesByUserLocation = (dispatch, userData) => {
    return leaveService.getLeaveTypesByUserLocation().then(resp => {
        let lCode = {};
        const lt = resp.data.data.map(x => {
            lCode[x.code] = { ...x }
            return {
                ...x,
                label: <span className='ess-list-item'><strong>{x.code}</strong> ({x.title})</span>
            }
        });
        const newData = { ...userData, userLeaveType: lt, leaveCode: lCode };
        dispatch(setData(newData));
        return {
            userLeaveType: resp.data.data,
            leaveTypeCode: lCode,
            userData: newData
        };
    });
}

export const generateRandomColor = () => {
    return '#' + Math.floor(Math.random() * 16777215).toString(16);
};

export const processMonthlyLeaves = (leaveData, lType) => {
    const monthlyCount = new Array(12).fill(0);
    leaveData.forEach(leave => {
        if (leave.startDate && leave.endDate) {
            const startDate = new Date(leave.startDate);
            const endDate = new Date(leave.endDate);
            const startMonth = startDate.getMonth();
            const endMonth = endDate.getMonth();
            if (leave.absenceCode === capitalize(lType.code)) {
                for (let month = startMonth; month <= endMonth; month++) {
                    monthlyCount[month]++;
                }
            }
        }
    });

    return monthlyCount;
};

export const basicOptionsbasicOptions = {
    maintainAspectRatio: false,
    aspectRatio: .8,
    plugins: {
        datalabels: {
            anchor: 'end',
            align: 'end',
            color: '#000',
            formatter: (value, context) => {
                return value; // Display the value
            },
        },
        legend: {
            labels: {
                color: '#495057'
            }
        }
    },
    scales: {
        x: {
            ticks: {
                color: '#495057'
            },
            grid: {
                color: '#ebedef'
            }
        },
        y: {
            ticks: {
                color: '#495057'
            },
            grid: {
                color: '#ebedef'
            },
            min: 0
        }
    }
};

export const lineChartOptions = {
    maintainAspectRatio: false,
    aspectRatio: .6,
    plugins: {
        datalabels: {
            anchor: 'end',
            align: 'end',
            color: '#000',
            formatter: (value, context) => {
                return value; // Display the value
            },
        },
        legend: {
            labels: {
                color: '#495057'
            }
        }
    },
    scales: {
        x: {
            ticks: {
                color: '#495057'
            },
            grid: {
                color: '#ebedef'
            }
        },
        y: {
            ticks: {
                color: '#495057'
            },
            grid: {
                color: '#ebedef'
            },
            min: 0
        }
    }
};

export const chartData = {
    labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July'],
    datasets: [
        {
            label: 'My First dataset',
            backgroundColor: '#42A5F5',
            data: [65, 59, 80, 81, 56, 55, 40]
        },
        {
            label: 'My Second dataset',
            backgroundColor: '#FFA726',
            data: [28, 48, 40, 19, 86, 27, 90]
        }
    ]
};

export const yearChartData = {
    labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July'],
    datasets: [
        {
            label: 'First Dataset',
            data: [65, 59, 80, 81, 56, 55, 40],
            fill: false,
            borderColor: '#42A5F5',
            tension: .4
        },
        {
            label: 'Second Dataset',
            data: [28, 48, 40, 19, 86, 27, 90],
            fill: false,
            borderColor: '#FFA726',
            tension: .4
        }
    ]
};